/**
 * Códigos de erro de permissão, comuns a várias rotas.
 */
export const AUTH_ERRORS = {
  /** 403 — o perfil do usuário não pode fazer isto (ex.: atendente alterando configuração da empresa). */
  NO_PERMISSION: "ERR_NO_PERMISSION"
} as const;

export type AuthErrorCode = (typeof AUTH_ERRORS)[keyof typeof AUTH_ERRORS];
